import { useContext } from 'react';
import { createNamedContext } from '@trinity/chat-components/utils';

type SelectedSurveyContextValue = {
  selectedSurvey: number;
};

export const SelectedSurveyContext = createNamedContext<SelectedSurveyContextValue>(undefined, 'SelectedSurveyContext');

export const useSelectedSurvey = () => useContext(SelectedSurveyContext);